// Mock data for Digital Marketing Portfolio

export const portfolioData = {
  hero: {
    name: "Aryan Shivhare",
    tagline: "Elevate with Aryan Shivhare",
    subtitle: "Digital Marketer | Model & Photographer | Freelancer",
    description: "Transforming brands through data-driven strategies, creative storytelling, and innovative social media solutions that deliver measurable results.",
    cta: {
      primary: "View My Work",
      secondary: "Get In Touch"
    }
  },

  services: [
    {
      id: 1,
      title: "Social Media Marketing",
      description: "Creating and executing strategies to promote brands on social media platforms. A mix of creativity, analytical skills, and marketing expertise to engage audiences, drive traffic, and achieve business objectives.",
      icon: "Share2"
    },
    {
      id: 2,
      title: "Photographer",
      description: "Creating visually compelling images that capture personality, mood, and essence. Professional portrait photography with technical skills, lighting mastery, and authentic connection.",
      icon: "Camera"
    },
    {
      id: 3,
      title: "Fashion Modelling",
      description: "Delivering professionalism in every shoot and campaign to build trust with brands. Experienced in runway, editorial, and commercial modeling.",
      icon: "User"
    },
    {
      id: 4,
      title: "Motion Videos",
      description: "Bringing ideas to life through dynamic visuals and engaging animations. Creating promotional videos, explainer animations, social media content, and motion-based storytelling.",
      icon: "Video"
    },
    {
      id: 5,
      title: "Website Development",
      description: "Creating custom websites designed to reflect your vision and meet business goals. Delivering sleek portfolios, robust e-commerce platforms, and personalized business websites crafted to perfection.",
      icon: "Globe"
    },
    {
      id: 6,
      title: "Search Engine Optimization",
      description: "Helping businesses rank higher on search engines and drive organic traffic. Tailored SEO strategies including keyword research, on-page optimization, and high-quality backlink building.",
      icon: "Search"
    },
    {
      id: 7,
      title: "Content Creation",
      description: "Crafting compelling content that resonates with audiences and brings ideas to life. From captivating blog posts to engaging social media content and professional copywriting.",
      icon: "FileText"
    },
    {
      id: 8,
      title: "Logo Designing",
      description: "Creating unique and memorable logos that perfectly capture brand essence. Tailored designs that make brands stand out and leave lasting impressions.",
      icon: "Palette"
    }
  ],

  projects: [
    {
      id: 1,
      title: "Berlin Fashion Week Coverage",
      category: "Social Media & Photography",
      description: "Complete social media coverage for The Garnette Report during Berlin Fashion Week, including runway photography, backstage content, and real-time social engagement.",
      image: "https://images.unsplash.com/photo-1762430790694-aedd36b4cb8c",
      tags: ["Fashion", "Event Coverage", "Social Media"]
    },
    {
      id: 2,
      title: "Digital Marketing Campaign",
      category: "Performance Marketing",
      description: "Multi-channel digital marketing campaign driving 300% ROI increase through strategic content and targeted advertising.",
      image: "https://images.unsplash.com/photo-1557838923-2985c318be48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc3NTA4MDM0NHww&ixlib=rb-4.1.0&q=85",
      tags: ["Digital Marketing", "ROI", "Strategy"]
    },
    {
      id: 3,
      title: "Brand Social Media Strategy",
      category: "Social Media Management",
      description: "Comprehensive social media strategy resulting in 250K+ follower growth and 5x engagement increase across platforms.",
      image: "https://images.unsplash.com/photo-1683721003111-070bcc053d8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxzb2NpYWwlMjBtZWRpYXxlbnwwfHx8fDE3NzUwODAzNDh8MA&ixlib=rb-4.1.0&q=85",
      tags: ["Social Media", "Growth", "Engagement"]
    },
    {
      id: 4,
      title: "Fashion Editorial Photography",
      category: "Photography",
      description: "High-fashion editorial shoot showcasing creative direction and professional photography for leading fashion brands.",
      image: "https://images.unsplash.com/photo-1601597565151-70c4020dc0e1",
      tags: ["Photography", "Fashion", "Editorial"]
    },
    {
      id: 5,
      title: "SEO Optimization Project",
      category: "SEO & Analytics",
      description: "Complete SEO overhaul achieving first-page rankings for 50+ keywords and 400% organic traffic increase.",
      image: "https://images.pexels.com/photos/270637/pexels-photo-270637.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      tags: ["SEO", "Analytics", "Organic Growth"]
    },
    {
      id: 6,
      title: "Runway Photography",
      category: "Event Photography",
      description: "Professional runway and event photography capturing the essence of fashion week shows and backstage moments.",
      image: "https://images.unsplash.com/photo-1762430815537-e140755eedf9",
      tags: ["Fashion", "Runway", "Events"]
    },
    {
      id: 7,
      title: "Creative Studio Session",
      category: "Photography",
      description: "Artistic studio photography session with creative direction, styling, and post-production for commercial campaigns.",
      image: "https://images.unsplash.com/photo-1704208316515-a32f81e373ef",
      tags: ["Studio", "Creative", "Commercial"]
    },
    {
      id: 8,
      title: "Team Collaboration Platform",
      category: "Digital Strategy",
      description: "Strategic digital transformation project improving team collaboration and workflow efficiency through modern tools.",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc3NTA4MDM0NHww&ixlib=rb-4.1.0&q=85",
      tags: ["Digital", "Strategy", "Collaboration"]
    }
  ],

  process: [
    {
      id: 1,
      step: "01",
      title: "Discovery & Strategy",
      description: "Understanding your brand, goals, and audience to craft a tailored strategy that aligns with your vision and business objectives."
    },
    {
      id: 2,
      step: "02",
      title: "Creative Development",
      description: "Developing compelling content, visuals, and campaigns that resonate with your target audience and reflect your brand identity."
    },
    {
      id: 3,
      step: "03",
      title: "Execution & Optimization",
      description: "Launching campaigns with precision, monitoring performance, and continuously optimizing for maximum impact and ROI."
    },
    {
      id: 4,
      step: "04",
      title: "Analysis & Growth",
      description: "Analyzing data insights, measuring success metrics, and scaling strategies for sustained growth and long-term success."
    }
  ],

  about: {
    name: "Aryan Shivhare",
    title: "Social Media Strategist | Freelancer | Model & Photographer",
    bio: "Hello! I'm Aryan Shivhare, a passionate advocate for leveraging the power of social media to build meaningful connections, spark engagement, and achieve impactful results. With a multifaceted background as a freelance social media strategist, model, and photographer, I bring a creative, authentic, and results-driven approach to the digital realm.",
    description: "My journey in digital marketing combines technical expertise with creative vision. I specialize in crafting data-driven strategies that don't just look good, but deliver measurable business results. From social media campaigns to SEO optimization, I help brands tell their story and connect with their audience in meaningful ways.",
    stats: [
      { label: "Projects", value: "150+" },
      { label: "Clients", value: "80+" },
      { label: "Years", value: "5+" }
    ]
  },

  brands: [
    { name: "TEDx", logo: "TEDx" },
    { name: "Berlin Fashion Week", logo: "BFW" },
    { name: "Bare Berlin", logo: "BARE" }
  ],

  contact: {
    email: "aryanshivhare004@gmail.com",
    phone: "+49 176 84341181",
    whatsapp: "https://wa.me/4917684341181",
    social: {
      instagram: "https://instagram.com/thisisaaryan",
      linkedin: "https://linkedin.com/in/aryanshivhare",
      twitter: "https://twitter.com/thisisaaryan"
    }
  }
};
